import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Menu } from "lucide-react";
import {
  Sheet,
  SheetContent,
  SheetTrigger,
  SheetClose,
} from "@/components/ui/sheet";
import { cn } from "@/lib/utils";
import { BuyButton } from "@/components/BuyButton";
import { Brand } from "@/components/layout/Brand";
import { NAV_LINKS } from "@/components/layout/navItems";
import { STORE } from "@/constants/testIds";

export const MobileMenu = () => {
  const [open, setOpen] = useState(false);
  return (
    <div className="xl:hidden">
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetTrigger asChild>
          <button
            type="button"
            aria-label="Open menu"
            data-testid={STORE.navMobileMenuButton}
            className="inline-flex h-11 w-11 items-center justify-center rounded-xl border border-white/15 bg-white/5 text-white transition-colors hover:bg-white/10"
          >
            <Menu className="h-5 w-5" />
          </button>
        </SheetTrigger>
        <SheetContent
          side="right"
          className="w-[86%] max-w-sm border-l border-[color:rgba(231,190,74,0.18)] bg-[var(--ibp-navy-950)] p-0 text-white"
        >
          <div className="flex items-center justify-between border-b border-white/10 px-5 py-4">
            <Brand testId={undefined} />
          </div>
          <div className="flex flex-col gap-1 px-3 py-4">
            {NAV_LINKS.map((l) => (
              <SheetClose asChild key={l.to}>
                <NavLink
                  to={l.to}
                  end={l.end}
                  className={({ isActive }) =>
                    cn(
                      "rounded-lg px-3 py-3 text-base font-medium transition-colors",
                      isActive
                        ? "bg-white/10 text-white"
                        : "text-white/80 hover:bg-white/5 hover:text-white"
                    )
                  }
                >
                  {l.label}
                </NavLink>
              </SheetClose>
            ))}
          </div>
          <div className="px-5 pb-6 pt-2">
            <SheetClose asChild>
              <div>
                <BuyButton testId="nav-mobile-primary-cta" fullWidth />
              </div>
            </SheetClose>
          </div>
        </SheetContent>
      </Sheet>
    </div>
  );
};

export default MobileMenu;
